var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MPMaterialInput',{attrs:{"id":_vm.id,"error":_vm.error,"type":"email","label":"Email","data-spec":_vm.dataSpec},on:{"blur":function($event){return _vm.$emit('blur', $event)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }